import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#e9ebee"
export default makeBasicTheme(mainColor)